import { Component } from "@angular/core";
import { EmbeddedViewContentComponent } from "../../embedded-view-content.component";

@Component({
  templateUrl: "./loading-indicator.component.html",
  selector: "sv-ng-loading-indicator",
  styleUrls: ["../../hide-host.scss"]
})
export class LoadingIndicatorComponent extends EmbeddedViewContentComponent {

}